import { render, staticRenderFns } from "./PanelByAccount.vue?vue&type=template&id=1264a3a0"
import script from "./PanelByAccount.vue?vue&type=script&lang=js"
export * from "./PanelByAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports